import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { OrganizationBranches } from './interface';
import { ApiService } from './../../Services/api.service';
import { StorageService } from './../../Services/storage.service';


export class Store<T>{
    private state$: BehaviorSubject<OrganizationBranches[]>;
    protected constructor(initialState: OrganizationBranches[] = []) {
        this.state$ = new BehaviorSubject(initialState);
    }
    get getValue(): OrganizationBranches[] {
        return this.state$.getValue();
    }
    get getState(): Observable<OrganizationBranches[]> {
        
        return this.state$.asObservable();
    }
    set setState(item: OrganizationBranches[]){
        this.state$.next(item);
    }
}


@Injectable()
export class OrgBranchStateManagement extends Store<OrganizationBranches>{
    constructor(
        private api: ApiService,
        private storage: StorageService
    ) {
        super();
    }

    AddBranch(newData: any): void {
        try {
            this.setState=newData;
            // const data = this.getValue();


        } catch (error) {
            console.log('Error ', error);
        }
    }

    get(): OrganizationBranches[] {
        let branches:any = this.getValue;
        // console.log('getData ', branches)

        return branches;
    }
    listen(): Observable<OrganizationBranches[]> {
        return this.getState;
    }
    async fetchBranchList(){
        let orgInfo = this.storage.get('userInfo');
        let obj = { orgID: orgInfo['orgID'] };
        let branchData = [], ping = 1, i = 0;
        while (ping) {
          obj['page'] = i + 1;
          i++;
          let res = await this.api.listBranches(obj).catch((e) => { console.log("Get Branch data"); });
          if (res && res['status'] == 'success') {
            if (res['data'].length <= 0) ping = 0;
            else {
                branchData = [...branchData, ...res['data']];
              this.setState = branchData; 
            }
          }else ping = 0;
        } 
    }
}